// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"wr_a big_b big_we"};